import React from 'react';
import { PencilIcon, EyeIcon, TrashIcon } from '@heroicons/react/24/outline';

const TaskActions = ({ task, onEditTask, onDeleteTask, isDeleting }) => {
  const handleDelete = () => {
    onDeleteTask(task.id);
  };

  switch (task.status) {
    case 'draft':
      return (
        <div className="flex items-center space-x-1.5 sm:space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-gray-300 px-1.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 sm:px-2"
          >
            <PencilIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">Resume</span>
            <span className="sm:hidden">Edit</span>
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-1.5 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50 sm:px-2"
          >
            <TrashIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            {isDeleting ? 'Deleting...' : <span className="hidden sm:inline">Delete</span>}
          </button>
        </div>
      );
    case 'validated':
      return (
        <div className="flex items-center space-x-1.5 sm:space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-green-300 px-1.5 py-1 text-xs font-medium text-green-700 hover:bg-green-50 sm:px-2"
          >
            <EyeIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">Continue</span>
            <span className="sm:hidden">View</span>
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-1.5 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50 sm:px-2"
          >
            <TrashIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            {isDeleting ? 'Deleting...' : <span className="hidden sm:inline">Delete</span>}
          </button>
        </div>
      );
    case 'set_algo_preferences':
      return (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-blue-300 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50"
          >
            <EyeIcon className="mr-1 h-4 w-4" />
            Continue
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
          >
            <TrashIcon className="mr-1 h-4 w-4" />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      );
    case 'cancelled':
      return (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
          >
            <PencilIcon className="mr-1 h-4 w-4" />
            Resume
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
          >
            <TrashIcon className="mr-1 h-4 w-4" />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      );
    case 'created':
    case 'ready_for_prompt':
      return (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-green-300 px-2 py-1 text-xs font-medium text-green-700 hover:bg-green-50"
          >
            <EyeIcon className="mr-1 h-4 w-4" />
            Continue
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
          >
            <TrashIcon className="mr-1 h-4 w-4" />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      );
    case 'pending_for_algorithm':
    case 'processing_algorithm':
      return (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-blue-300 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50"
          >
            <EyeIcon className="mr-1 h-4 w-4" />
            View Status
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
          >
            <TrashIcon className="mr-1 h-4 w-4" />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      );
    case 'completed':
      return (
        <div className="flex items-center space-x-1.5 sm:space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-gray-300 px-1.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 sm:px-2"
          >
            <EyeIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">View</span>
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-1.5 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50 sm:px-2"
          >
            <TrashIcon className="mr-1 h-3 w-3 sm:h-4 sm:w-4" />
            {isDeleting ? 'Deleting...' : <span className="hidden sm:inline">Discard</span>}
          </button>
        </div>
      );
    case 'sessions_scheduled':
      return (
        <button
          onClick={() => onEditTask(task)}
          className="inline-flex items-center rounded border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
        >
          <EyeIcon className="mr-1 h-4 w-4" />
          View
        </button>
      );
    case 'failed':
      return (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEditTask(task)}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50"
          >
            <PencilIcon className="mr-1 h-4 w-4" />
            Retry
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
          >
            <TrashIcon className="mr-1 h-4 w-4" />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      );
    default:
      return (
        <button
          onClick={() => onEditTask(task)}
          className="inline-flex items-center rounded border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
        >
          <EyeIcon className="mr-1 h-4 w-4" />
          Open
        </button>
      );
  }
};

export default TaskActions;
